import { textFormatting, customization } from '@yola/ws-sdk';
import getCustomTextColor from '../../website-design/helpers/get-custom-text-color';
import getCompiledCurrentPalette from '../../website-design/helpers/get-compiled-current-palette';
import getCircleBracketsContent from '../../utils/get-circle-brackets-content';
import { AVAILABLE_SURFACES } from '../constants/common';

const generateBlockCustomOptionsStylesheet = (
  textColorStylesheet,
  globalStylesRule,
  usedTextOptions,
  blockId
) => {
  const cssRules = [];

  if (textColorStylesheet) {
    const rootVariableMap = textFormatting.helpers.getCssRootVariablesMap();

    const { variables: paletteVariables } = getCompiledCurrentPalette();
    const customSurfaceIds = Object.keys(paletteVariables.schemes).filter((id) =>
      id.startsWith(customization.constants.CUSTOM_COLOR_SCHEME_PREFIX)
    );
    const allSurfaces = [...AVAILABLE_SURFACES, ...customSurfaceIds];

    const surfacesRules = allSurfaces.reduce((accum, surfaceName) => {
      const variablesValues = usedTextOptions
        .map((textVariableName) => {
          let color = getCustomTextColor(textVariableName, surfaceName, paletteVariables);
          if (!color) return '';

          if (color.includes('var')) {
            color = rootVariableMap[getCircleBracketsContent(color)];
          }

          return `${textVariableName}: ${color};`;
        })
        .join('');

      return `${accum} .${surfaceName} {${variablesValues}}`;
    }, '');

    const blockPrefix = blockId.substring(0, blockId.lastIndexOf('-'));
    const newBlockSelector = `[id^="${blockPrefix}-"]`;

    const textColorRules = Array.from(textColorStylesheet.cssRules)
      .filter((rule) => rule.selectorText.includes(blockId))
      .map(({ selectorText, style }) => {
        const selector = selectorText.replace(`#${blockId}`, newBlockSelector);

        const blockRule = style.cssText
          .split(';')
          .filter(Boolean)
          .map((itm) => {
            const [variableName, color] = itm.split(':');
            let rootColor = color;
            if (rootColor.includes('var')) {
              rootColor = rootVariableMap[getCircleBracketsContent(rootColor)];
            }
            return `${variableName}: ${rootColor};`;
          })
          .join('');

        return `${selector} {${blockRule}}`;
      })
      .join('');

    cssRules.push(surfacesRules, textColorRules);
  }

  if (globalStylesRule) {
    cssRules.push(globalStylesRule.cssText);
  }

  return cssRules.join(' ');
};

export default generateBlockCustomOptionsStylesheet;
